import { render, staticRenderFns } from "./TicketsSystemAddForm.vue?vue&type=template&id=4b72a7a4&"
import script from "./TicketsSystemAddForm.vue?vue&type=script&lang=js&"
export * from "./TicketsSystemAddForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports